// extracted by mini-css-extract-plugin
export default {"stack":"inputs_stack__XGven","horizontalWithLabel":"inputs_horizontalWithLabel__Clcy4","horizontalWithoutLabel":"inputs_horizontalWithoutLabel__vcT2S"};